const headerMenu = [
    {
      name: 'Home',
      to: '/'
    },
    {
      name: 'About me',
      to: '/about'
    },
    {
      name: 'Skills',
      to: '/skills'
    },
    {
      name: 'Portfolio',
      to: '/portfolio'
    },
    {
      name: 'Contact',
      to: '/contact'
    },
  ];

  export default headerMenu;
